import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs-wrapper" }
const _hoisted_2 = ["aria-selected", "aria-disabled", "disabled", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "tabs-underline-filler"
}
const _hoisted_4 = { class: "tab-panels" }
const _hoisted_5 = ["aria-labelledby", "hidden"]

import { computed } from 'vue'

export interface Tab {
  id: string | number
  label: string
  disabled?: boolean
  completed?: boolean
  valid?: boolean
  visible?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {},
    variant: { default: 'default' },
    modelValue: { default: undefined }
  },
  emits: ["update:modelValue", "tab-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const activeTab = computed({
  get: () => props.modelValue ?? props.tabs.find((t) => !t.disabled)?.id,
  set: (val) => emit('update:modelValue', val!),
})

function selectTab(tab: Tab) {
  if (tab.disabled) return
  activeTab.value = tab.id
  emit('tab-change', tab)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.variant === 'default' ? 'tab-list' : 'tab-list-underline'),
      role: "tablist"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs.filter(tab => tab.visible), (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          role: "tab",
          "aria-selected": activeTab.value === tab.id,
          "aria-disabled": tab.disabled,
          disabled: tab.disabled,
          class: _normalizeClass([
          _ctx.variant === 'default' ? 'tab-btn-default' : 'tab-btn-underline',
          { active: activeTab.value === tab.id },
          { disabled: tab.disabled },
          { completed: tab.completed && activeTab.value !== tab.id },
        ]),
          onClick: ($event: any) => (selectTab(tab))
        }, _toDisplayString(tab.label), 11, _hoisted_2))
      }), 128)),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (_ctx.variant === 'underline')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ], 2),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'panel-' + tab.id,
          role: "tabpanel",
          "aria-labelledby": String(tab.id),
          hidden: activeTab.value !== tab.id,
          class: _normalizeClass(['tab-panel', { 'tab-panel--active': activeTab.value === tab.id }])
        }, [
          _renderSlot(_ctx.$slots, tab.id, { tab: tab })
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})